<template>
  <div class="manager-ponto">
    <div>
      <PageTitle isBack="true" link="rh" fontSize="25" icon="fa fa-microchip"
        title="Recursos Humanos // Gerenciamento de ponto" />
    </div>
    <!-- filtros da lista -->
    <div class="container-ponto">
      <header>
        <div class="search-box">
          <span>Nome</span>
          <vs-input @input="inputSearchName" icon="search" style="width: 100%" v-model="name" />
          <div v-if="searchBox">
            <vs-list class="search-selected-ponto">
              <div class="close-box" @click="clickCloseBox">X</div>
              <vs-list-item v-for="(person, index) in employeeData" :key="index" class="item-selected"
                :title="person.nome">
                <vs-button color="success" @click="clickFunc(person)" icon="add_box"></vs-button>
              </vs-list-item>
            </vs-list>
          </div>
        </div>
        <div class="box-item">
          <span>Status</span>
          <b-form-select style="width: 180px" icon="arrow_downward" :options="dataStatus" v-model="status"
            @input="eventSelectedStatus"></b-form-select>
        </div>

        <div class="box-item">
          <span class="box-tem">Data De</span>
          <input type="date" v-model="dateDe" />
        </div>

        <div class="box-item">
          <span class="box-tem">Data Até</span>
          <input type="date" v-model="dateAte" />
        </div>
        <div class="search-box">
          <span>Departamento</span>
          <vs-input icon="search" v-model="department" @input="inputSearcDepartment" style="width: 100%" />
          <div v-if="searchBoxDepartment">
            <vs-list class="search-selected-ponto">
              <div class="close-box" @click="clickCloseBox">X</div>
              <vs-list-item v-for="(depart, index) in departmentData" :key="index" class="item-selected"
                :title="depart.qbDescric">
                <vs-button color="success" @click="clickDepart(depart)" icon="add_box"></vs-button>
              </vs-list-item>
            </vs-list>
          </div>
        </div>
        <button class="btn-serach-ponto" @click="clickSearch">Pesquisar</button>
      </header>
      <!-- fim -->
      <!-- lista de colaboradores -->
      <div class="table-collaborator-ponto">
        <div class="header-table-ponto">
          <div>
            <h4>Colaboradores:</h4>
            <button @click="clickImportJustify" v-show="status == 'PendenteRH'" style="background-color: #0f6035;">Importar Justificativas...</button>
          </div>

          <div>
            <h4>Total: {{ pontoData.length }}</h4>
            <button class="btn-serach-ponto" @click="exportarXlsx" style="margin-left: 15px;">
              Exportar XLSX
            </button>
          </div>
        </div>
        <table>
          <tr>
            <th class="area-check">
              <input class="check-custom" v-model="checkAll" type="checkbox" />
            </th>
            <th>
              <b>Matrícula</b>
            </th>
            <th>
              <b>Nome</b>
            </th>
            <th>
              <b>Data</b>
            </th>
            <th>
              <b>Horário</b>
            </th>
            <th>
              <b>Departamento</b>
            </th>
            <th>
              <b>Gestor</b>
            </th>
            <th>
              <b>Motivo</b>
            </th>
            <th>
              <b>Importado</b>
            </th>
            <th>
              <b>Aponta</b>
            </th>
            <th style="text-align: center;" v-if="status == 'PendenteRH'">
              <b>Ação</b>
            </th>
          </tr>
          <tr v-for="(ponto, index) in pontoData" :key="index">
            <td class="area-check">
              <input class="check-custom" type="checkbox" v-model="ponto.check" />
            </td>
            <td>{{ ponto.matricula }}</td>
            <td>{{ ponto.name }}</td>
            <td>{{ ponto.date }}</td>
            <td>{{ ponto.hour }}</td>
            <td>{{ ponto.department }}</td>
            <td>{{ ponto.boss }}</td>
            <td>{{ ponto.reason }}</td>
            <td style="text-align: center;">
              <div class="chip-aponta-yes" v-if="
                ponto.imported == 1 || ponto.imported == 2
              ">
                <span>SIM</span>
              </div>
              <div class="chip-aponta-no" v-else>
                <span>NÃO</span>
              </div>
            </td>
            <td style="text-align: center;">
              <div class="chip-aponta-yes" v-if="ponto.imported == 2">
                <span>SIM</span>
              </div>
              <div class="chip-aponta-no" v-else>
                <span>NÃO</span>
              </div>
            </td>
            <td style="text-align: center;" v-if="status == 'PendenteRH'">
              <button class="btn-reject-ponto" @click="clickDiscarte(ponto)">Rejeitar</button>
            </td>
          </tr>
        </table>
      </div>
      <!-- fim -->

      <!-- poupap para descartar -->
      <vs-popup class="holamundo" title="Deseja realmente rejeitar essa justificativa?" :active.sync="popupActivo">
        <div>
          <vs-textarea label="Digite um motivo" v-model="textReason" />
          <div>
            <vs-button color="success" @click="clickYesDiscarte" type="filled">Sim</vs-button>
            <vs-button color="danger" @click="clickNoDiscarte" type="filled">Não</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { baseApiUrlRH } from "@/global";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { EventBusExpenses } from "@/eventBus/eventBusExpenses";

import PageTitle from "@/components/template/PageTitle";
//configuração das mensagens
const configMessage = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "error",
  duration: 5000
};

const configMessageYes = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "success",
  duration: 3000
};

export default {
  name: "ManagerPonto",
  components: { PageTitle },
  data() {
    return {
      name: null,
      selectedIdEmployee: null,
      selectedDepartmentEmployee: null,
      status: "PendenteRH",
      dateDe: null,
      dateAte: null,
      department: null,
      loading: false,
      employeeData: [],
      departmentData: [],
      dataStatus: [
        { text: "Pendente RH", value: "PendenteRH" },
        { text: "Pendente Gestor", value: "PendenteGestor" },
        { text: "Importados", value: "Importado" },
        { text: "Apontados", value: "Aponta" }
      ],
      pontoData: [],
      searchBox: false,
      searchBoxDepartment: false,
      popupActivo: false,
      selectedJustify: null,
      textReason: null,
      checkAll: null
    };
  },

  methods: {
    async inputSearchName() {
      this.searchBox = true;
      await axios
        .get(`${baseApiUrlRH}/employee/byName/${this.name}`)
        .then(resp => {
          this.employeeData = resp.data;
        });
      if (this.employeeData.length <= 0) {
        this.searchBox = false;
      }
    },
    async inputSearcDepartment() {
      this.searchBoxDepartment = true;
      await axios
        .get(`${baseApiUrlRH}/employee/byDepartmentName/${this.department}`)
        .then(resp => {
          this.departmentData = resp.data;
        });
      if (this.departmentData.length <= 0) {
        this.searchBoxDepartment = false;
      }
    },
    clickFunc(person) {
      this.selectedIdEmployee = person.matricula;
      this.name = person.nome;
      this.searchBox = false;
    },
    clickDepart(depart) {
      this.selectedDepartmentEmployee = depart.qbDepto;
      this.department = depart.qbDescric;
      this.searchBoxDepartment = false;
    },
    // carrega lista de justificativas
    async searchEmployee(filter) {
      this.$vs.loading({ text: "Carregando lista..." });
      await axios
        .post(`${baseApiUrlRH}/employee/search`, filter)
        .then(resp => {
          this.pontoData = resp.data;
          console.log(this.pontoData);
        })
        .catch(error => {
          this.$toasted.show(
            "Estamos com problema na conexão, por favor tente mais tarde!",
            configMessage
          );
        });
      this.$vs.loading.close();
    },
    eventSelectedStatus() {
      this.clickSearch();
    },
    async clickSearch() {
      // --- VALIDAÇÕES DAS DATAS ---
      if (this.dateDe && !this.dateAte) {
        this.$toasted.show(
          "Informe a Data Até para pesquisar por intervalo!",
          configMessage
        );
        return;
      }

      if (!this.dateDe && this.dateAte) {
        this.$toasted.show(
          "Informe a Data De para pesquisar por intervalo!",
          configMessage
        );
        return;
      }

      if (this.dateDe && this.dateAte && this.dateAte < this.dateDe) {
        this.$toasted.show(
          "A Data Até não pode ser menor que a Data De!",
          configMessage
        );
        return;
      }
      const filter = {
        matricula:
          this.selectedIdEmployee == "" ? null : this.selectedIdEmployee,
        status: this.status,
        dateDe: this.dateDe == "" ? null : this.dateDe,
        dateAte: this.dateAte == "" ? null : this.dateAte,
        departmentId:
          this.selectedDepartmentEmployee == ""
            ? null
            : this.selectedDepartmentEmployee
      };

      await this.searchEmployee(filter);
    },
    async clickImportJustify() {
      let listSelected = this.pontoData.filter(ponto => ponto.check === true);

      if (listSelected.length <= 0) {
        this.$toasted.show(
          "Selecione ao menos uma justificativa para importar!",
          configMessage
        );
        return;
      }

      const justify = {
        listPontos: listSelected,
        personRegistration: sessionStorage.getItem("@matricula")
      };

      this.$vs.loading({ text: "Importando as justificativas..." });
      await axios
        .post(`${baseApiUrlRH}/employee/import`, justify)
        .then(resp => {
          this.$toasted.show(resp.data.message, configMessageYes);
          this.listStartJustifyPage();
        })
        .catch(error => {
          this.$toasted.show(
            "Não foi possível importar as justificativas, possivelmente estamos com problemas de conexão, tente mais tarde!",
            configMessage
          );
          this.$vs.loading.close();
        });
      this.$vs.loading.close();
    },

    async clickYesDiscarte() {
      if (
        this.textReason == null ||
        this.textReason == "" ||
        this.textReason.trim().length == 0
      ) {
        this.$toasted.show(
          "Digite o motivo com no mínimo de 10 caracteres para rejeitar a justificativa!",
          configMessage
        );
        return;
      }

      const discart = {
        requestMarkId: this.selectedJustify.pontoMarkId,
        reason: this.textReason
      };

      this.$vs.loading({ text: "rejeitando a justificativa..." });
      await axios
        .post(`${baseApiUrlRH}/ponto`, discart)
        .then(resp => {
          this.popupActivo = false;
          this.listStartJustifyPage();
          this.$toasted.show(resp.data.message, configMessageYes);
        })
        .catch(error => {
          this.$toasted.show(
            "Não foi possível rejeitar a justificativa, possivelmente estamos com problemas de conexão, tente mais tarde!",
            configMessage
          );
          this.$vs.loading.close();
        });
      this.$vs.loading.close();
    },
    clickNoDiscarte() {
      this.popupActivo = false;
    },

    clickCloseBox() {
      this.searchBox = false;
      this.searchBoxDepartment = false;
    },
    clickDiscarte(justify) {
      this.selectedJustify = justify;
      this.textReason = null;
      this.popupActivo = true;
    },
    listStartJustifyPage() {
      // filtro da pesquisa
      const filter = {
        matricula: null,
        status: "PendenteRH",
        date: null,
        departmentId: null
      };

      this.searchEmployee(filter);
    },
    checkPontoList(checkItens) {
      this.pontoData.forEach(ponto => {
        ponto.check = checkItens;
      });
    },
    exportarXlsx() {
      if (!this.pontoData || this.pontoData.length === 0) {
        this.$toasted.show("Nenhuma informação para exportar!", {
          type: "error"
        });
        return;
      }

      // Mapeia os dados para colunas mais amigáveis
      const dados = this.pontoData.map(p => ({
        "Matrícula": p.matricula,
        "Nome": p.name,
        "Data": p.date,
        "Horário": p.hour,
        "Departamento": p.department,
        "Gestor": p.boss,
        "Motivo": p.reason,
        "Importado": p.imported == 1 || p.imported == 2 ? "SIM" : "NÃO",
        "Aponta": p.imported == 2 ? "SIM" : "NÃO",
      }));

      // Cria a planilha
      const worksheet = XLSX.utils.json_to_sheet(dados);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Ponto");

      // Gera arquivo excel
      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      // Faz download
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), "ponto.xlsx");
    }
  },

  watch: {
    checkAll() {
      this.checkPontoList(this.checkAll);
    }
  },
  mounted() {
    this.listStartJustifyPage();
  }
};
</script>

<style scoped src="./style.css"></style>
